import styled from 'styled-components';

export const Main = styled('main')`
  flex-grow: 1;
`;
